const progressActiveLarge = {
    svg: '<svg style="width:1.50rem; height:1.50rem;" viewBox="0 0 24 24"><path d="M23.25 12c0 6.213-5.037 11.25-11.25 11.25S.75 18.213.75 12 5.787.75 12 .75 23.25 5.787 23.25 12M9.548 8.525l1.068-1.058 4.439 4.493-4.524 4.567-1.07-1.05 3.466-3.517z" clip-rule="evenodd"/></svg>',
};

export { progressActiveLarge as default };
